<template>
        <div class="container">
            <div class="shop-area left-tabs">
                <!-- <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                        <div class="sidebar">
                            <ul class="nav">
                                
                                
                                

                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
                        
                    </div>
                </div> -->
                <router-view></router-view>
            </div>
        </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "myaccount",
    metaInfo: {
        title: 'My Account',
        meta: [
            { charset: 'utf-8' },
            { name: 'title', content:  'My Account'},
            { name: 'description', content: 'This is my account page'},
            { name: 'keywords', content:  'renkaatalle, Renkaatalle.fi, my account'},
            { name: 'robots', content: 'index,follow'}
        ]
    },
    data() {
      return {
          currentUserPermissions: []
      }
    },
    watch:{
        userDetails: {
            immediate: true,
            handler(newVal, oldVal) {
                if(newVal.role == 'kavo_member' && this.virtualUserDetails)   {
                    this.currentUserPermissions = this.virtualUserDetails.permissions;
                } else {
                    this.currentUserPermissions = newVal.permissions;
                }
            }
        }
    },
    computed: {
        ...mapGetters('auth', ['userDetails', 'userPermission', 'virtualUserDetails']),
    }
};
</script>